<ng-container *ngIf="displayedGroup$ | async as group">
  {{ group.description }}
</ng-container>
